import { AxiosResponse } from 'axios'
import { API_GET_STATES } from 'constants/apiUrl'
import { privateInstance } from 'services/axios/privateInstance'
import { IState } from 'typescript/interfaces/companies'

export const getStates = () => privateInstance.get<any, AxiosResponse<IState[]>>(API_GET_STATES)
